module.exports = __webpack_public_path__ + "static/media/close.6e00c017.svg";